<button
  mat-icon-button
  class="header-modal-btn"
  [class.header-modal-btn-active]="isShowFileLibrary()"
  [matTooltip]="'Сменить режим просмотра'"
  (click)="handleClick('showFileLibrary')"
>
  <mat-icon class="header-modal-btn-icon">apps</mat-icon>
</button>
<button
  mat-icon-button
  class="header-modal-btn"
  [matTooltip]="'История изменений'"
  (click)="handleClick('history')"
>
  <mat-icon class="header-modal-btn-icon">info</mat-icon>
</button>
<button
  mat-icon-button
  class="header-modal-btn"
  [class.header-modal-btn-active]="isActiveUploadFile()"
  [matTooltip]="'Загрузить файл(ы)'"
  (click)="handleClick('upload')"
>
  <mat-icon class="header-modal-btn-icon">upload</mat-icon>
</button>
<button
  mat-icon-button
  class="header-modal-btn"
  [matTooltip]="'Скачать архив'"
  (click)="handleClick('download')"
>
  <mat-icon class="header-modal-btn-icon">download</mat-icon>
</button>
